/* eslint-disable no-mixed-operators */
(function () {
    'use strict';

    /**
     * TODO: delay, animation function, placement function, inside, tooltip or title,
     * remove standard tooltip from title (break bindings), multiple triggers, html
     * tooltips, selector delegate,
     */
    angular
        .module('app')
        .directive('tooltipPopup', tooltipPopupDirective)
        .directive('tooltip', tooltipDirective);

    tooltipDirective.$inject = ['$compile', '$timeout', 'i18n',];

    function tooltipPopupDirective() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: '/templates/directives/tooltip.directive.html'
        };
    }

    function tooltipDirective($compile, $timeout, i18n) {
        var directive = {
            restrict: 'A',
            scope: {
                tooltipTitle: '@tooltipText',
                placement: '@tooltipPlacement',
                animation: '&tooltipAnimation'
            },
            link: link,
        };
        var template = '<tooltip-popup></tooltip-popup>';

        return directive;


        function link(scope, element) {
            var tooltip = null;
            var transitionTimeout = null;
            if (scope.tooltipTitle) {
                i18n.get(scope.tooltipTitle).then(function (translation) {
                    // element.attr('placeholder', translation);
                    scope.tooltipTitle = translation;
                    tooltip = $compile(template)(scope);
                }, function () {
                    tooltip = $compile(template)(scope);
                })
                    .finally(function () {
                        // Register the event listeners.
                        element.bind('mouseenter', function () {
                            scope.$apply(show);
                        });
                        element.bind('mouseleave', function () {
                            scope.$apply(hide);
                        });
                    });
            }

            function show() {
                var position = {},
                    ttWidth = 0,
                    ttHeight = 0,
                    ttPosition = {};

                // If no placement was provided, default to 'top'.
                scope.placement = scope.placement || 'top';

                // If there is a pending remove transition, we must cancel it, lest the
                // toolip be mysteriously removed.
                if (transitionTimeout) {
                    $timeout.cancel(transitionTimeout);
                }

                // Lazy compile the tooltip element
                // FIXME: For some reason, this does *not* always work correctly on the
                // *first* run, but does so on all subsequent runs.
                //tooltip = tooltip ||  $compile( template )( scope );

                // Set the initial positioning.
                tooltip.css({ top: 0, left: 0, display: 'block' });

                // Now we add it to the DOM because need some info about it. But it's not
                // visible yet anyway.
                // element.after(tooltip);
                angular.element(document.body).append(tooltip);

                // Get the position of the directive element.
                position = getPosition();

                // Get the height and width of the tooltip so we can center it.
                ttWidth = tooltip.prop('offsetWidth');
                ttHeight = tooltip.prop('offsetHeight');

                // Calculate the tooltip's top and left coordinates to center it with
                // this directive.
                switch (scope.placement) {
                    case 'right':
                        ttPosition = {
                            top: position.top + position.height / 2 - ttHeight / 2 + 'px',
                            left: position.left + position.width + 'px'
                        };
                        break;
                    case 'bottom':
                        ttPosition = {
                            top: position.top + position.height + 'px',
                            left: position.left + position.width / 2 - ttWidth / 2 + 'px'
                        };
                        break;
                    case 'left':
                        ttPosition = {
                            top: position.top + position.height / 2 - ttHeight / 2 + 'px',
                            left: position.left - ttWidth + 'px'
                        };
                        break;
                    default:
                        ttPosition = {
                            top: position.top - ttHeight + 'px',
                            left: position.left + position.width / 2 - ttWidth / 2 + 'px'
                        };
                        break;
                }

                // Now set the calculated positioning.
                tooltip.css(ttPosition);

                // And show the tooltip.
                scope.isOpen = true;

                // Automatically close tooltip if existed too long
                setTimeout(function () {
                    hide();
                }, 5000);
            }

            // Hide the tooltip popup element.
            function hide() {
                // First things first: we don't show it anymore.
                //tooltip.removeClass( 'in' );
                scope.isOpen = false;

                // And now we remove it from the DOM. However, if we have animation, we
                // need to wait for it to expire beforehand.
                // FIXME: this is a placeholder for a port of the transitions library.
                if (angular.isDefined(scope.animation)) {
                    transitionTimeout = $timeout(function () {
                        tooltip.remove();
                    }, 200);
                } else {
                    tooltip.remove();
                }
            }

            // Calculate the current position and size of the directive element.
            function getPosition() {
                return {
                    width: element.prop('offsetWidth'),
                    height: element.prop('offsetHeight'),
                    top: element.prop('offsetTop'),
                    left: element.prop('offsetLeft')
                };
            }

        }
    }

})();